import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { Paso4pagePageRoutingModule } from './paso4page-routing.module';

import {MiscomponentesModule} from '../miscomponentes/componentes.module'

import { Paso4pagePage } from './paso4page.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    Paso4pagePageRoutingModule,
    MiscomponentesModule
  ],
  declarations: [
    Paso4pagePage,
 
  ]
})
export class Paso4pagePageModule {}
